import { useEffect, useState } from "react"

import { Card, Col, Row, Spin, Typography } from "antd"
import { createSearchParams, useNavigate } from "react-router-dom"

import { SvgImage } from "@/components/_Shared/SvgImage/SvgImage"

import classes from "../../Account/Balance/Balance.module.scss"

import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"

import { paths } from "@/router/paths"

import { getMoney } from "@/utils/formatNumber"


const { Title } = Typography

export type BalanceProps = {}

export const Balance = (props: BalanceProps) => {
  const { data: customers, isLoading: customersIsLoading } = useCustomerQuery()
  const navigate = useNavigate()

  const [balanceSum, setBalanceSum] = useState<number>(0)
  const [sumOrderSum, setSumOrderSum] = useState<number>(0)
  const [paidOrderSum, setPaidOrderSum] = useState<number>(0)
  const [availableSum, setAvailableSum] = useState<number>(0)

  const onClickOrderedBalance = () => navigate({
    pathname: paths.orders,
    search: createSearchParams({
      active: "true"
    }).toString()
  })

  const onClickBalanceOrAvailable = () => navigate(paths.finance)

  useEffect(() => {
      setBalanceSum(customers?.response.data.reduce((sum, current) => sum + current.balance, 0) ?? 0)
      setSumOrderSum(customers?.response.data.reduce((sum, current) => sum + current.sumOrder, 0) ?? 0)
      setPaidOrderSum(customers?.response.data.reduce((sum, current) => sum + current.paidOrderSum, 0) ?? 0)
      setAvailableSum(customers?.response.data.reduce((sum, current) => sum + current.availableSum, 0) ?? 0)
  }, [customers])
  
  return (
    <Spin spinning={customersIsLoading}>
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(balanceSum)}
              <h5>&nbsp;</h5>
            </Title>
            <h5>Баланс</h5>
            <SvgImage src="wallet-icon.svg" height={68} width={68} className={`${classes.balanceIconSvg} ${classes.wallet}`} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickOrderedBalance}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(sumOrderSum)}
              <h5>оплачено {getMoney(paidOrderSum)}</h5>
            </Title>
            <h5>Сумма заказов в работе</h5>
            <SvgImage src="cyrcle-icon.svg" height={72} width={72} className={`${classes.balanceIconSvg} ${classes.cyrcle}`} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(availableSum)}
              <h5>&nbsp;</h5>
            </Title>
            <h5>Сумма доступная для заказа</h5>
            <SvgImage src="check-icon.svg" height={65} width={65} className={`${classes.balanceIconSvg} ${classes.check}`} />
          </Card>
        </Col>
      </Row>
    </Spin>
  )
}